;(function (AUI, Liferay, VersionManager) {
  'use strict'

  function moduleUrl (url) {
    var fullPath = Liferay.ThemeDisplay.getPathThemeRoot() + '/js/modules/' + url
    return VersionManager.buildUrl(fullPath)
  }

  AUI().applyConfig({
    modules: {
      'ent-portlet': {
        fullpath: moduleUrl('portlet.js'),
      },
      'ent-validator-builder': {
        fullpath: moduleUrl('validator-builder.js'),
      },
      'ent-filter-combo': {
        fullpath: moduleUrl('ent-filter-combo.js'),
      },
      'ent-auto-complete': {
        fullpath: moduleUrl('ent-auto-complete.js'),
      },
      'ent-custom-form-validator': {
        fullpath: moduleUrl('custom-form-validator.js'),
        requires: ['aui-form-validator']
      }
    }
  })

})(window.AUI || window.YUI, window.Liferay, window.VersionManager)
